import _regenerator from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, vShow as _vShow, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  id: "app-sidebar-1",
  class: "bg-surface-0 h-screen h-[100dvh] hidden lg:block flex-shrink-0 absolute lg:static left-0 top-0 z-[1000] border-r border-surface-200 select-none w-[280px]"
};
var _hoisted_2 = {
  class: "flex flex-col h-full"
};
var _hoisted_3 = {
  class: "flex items-center gap-4 p-3 pb-2 h-[4rem]"
};
var _hoisted_4 = {
  class: "w-9 h-9 flex items-center justify-center border border-surface-200 rounded-lg p-1"
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "flex flex-col gap-0.25 text-sm"
};
var _hoisted_7 = {
  class: "text-xs"
};
var _hoisted_8 = {
  class: "pb-2 px-2"
};
var _hoisted_9 = {
  class: "overflow-y-auto overflow-x-hidden flex-1 p-2 flex flex-col"
};
var _hoisted_10 = {
  class: "list-none m-0 flex flex-col gap-1"
};
var _hoisted_11 = ["onClick"];
var _hoisted_12 = {
  class: "flex items-center gap-3 w-full"
};
var _hoisted_13 = {
  class: "flex items-center justify-between gap-1 w-full"
};
var _hoisted_14 = {
  key: 0,
  class: "ml-auto inline-block bg-surface-400 rounded-xl font-semibold leading-none text-xs py-0.5 text-surface-0 dark:text-surface-900 h-fit w-fit px-2"
};
var _hoisted_15 = {
  key: 0,
  class: "ml-auto inline-block bg-primary rounded-xl font-semibold px-2 leading-none text-xs py-0.5 text-surface-0 h-fit w-fit"
};
var _hoisted_16 = {
  key: 1,
  class: "ml-auto inline-block bg-surface-400 rounded-xl font-semibold leading-none text-xs py-0.5 text-surface-0 dark:text-surface-900 h-fit w-fit px-2"
};
var _hoisted_17 = {
  class: "mt-auto relative inline-block z-[200]"
};
var _hoisted_18 = ["src"];
var _hoisted_19 = {
  class: "font-medium text-sm leading-tight"
};
var _hoisted_20 = {
  class: "list-none m-0"
};
var _hoisted_21 = {
  class: "flex flex-col items-center w-full justify-center py-1 px-2"
};
var _hoisted_22 = {
  class: "border-t border-surface-200 py-1 px-2 w-full"
};
var _hoisted_23 = {
  class: "font-medium text-sm leading-tight"
};
var _hoisted_24 = {
  class: "font-medium text-sm leading-tight"
};
var _hoisted_25 = {
  class: "border-t border-surface-200 py-1 px-2"
};
var _hoisted_26 = {
  class: "font-medium text-sm leading-tight text-red-500 dark:text-red-700"
};
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { $tf } from "@/plugins/i18n";
import { PRIVILEGES } from "@/utils/const";
import network from "@/utils/network";
import Popover from "primevue/popover";
import LanguageSelector from "@/components/common/LanguageSelector.vue";
import ThemeSelector from "@/components/common/ThemeSelector.vue";
import CommandKSearch from "@/components/search/CommandKSearch.vue";
export default {
  __name: 'SideMenu',
  setup: function setup(__props) {
    var axios = network.createAxiosInstance();
    var store = useStore();
    var route = useRoute();
    var router = useRouter();
    var profileMenu = ref();
    var openedMenus = ref([]);
    var pendingRequests = ref(null);
    var overtimeRequests = ref(null);

    // Store getters
    var displayName = computed(function () {
      return store.getters["session/displayName"];
    });
    var avatar = computed(function () {
      return store.getters["session/avatar"];
    });
    var env = computed(function () {
      return store.getters["env/getField"];
    });
    var tenantBadge = computed(function () {
      return env.value("TENANT_BADGE");
    });
    var pendingRequestsCount = computed(function () {
      var _pendingRequests$valu, _overtimeRequests$val;
      return (((_pendingRequests$valu = pendingRequests.value) === null || _pendingRequests$valu === void 0 ? void 0 : _pendingRequests$valu.totalPendingCount) || 0) + (((_overtimeRequests$val = overtimeRequests.value) === null || _overtimeRequests$val === void 0 ? void 0 : _overtimeRequests$val.totalPendingCount) || 0);
    });
    var logo = computed(function () {
      return process.env.VUE_APP_MENU_LOGO_CLOSED;
    });

    // Authority helpers
    var hasAnyAuthority = function hasAnyAuthority() {
      var _store$getters;
      return (_store$getters = store.getters)["session/hasAnyAuthority"].apply(_store$getters, arguments);
    };

    // Menu items
    var menuItems = computed(function () {
      return [{
        icon: "fa-regular fa-gauge-high",
        label: $tf("sidebar.dashboard|Dashboard"),
        classList: [],
        visible: true,
        key: "dashboard",
        comingSoon: true,
        items: []
      }, {
        icon: "fa-regular fa-calendar",
        label: $tf("sidebar.time|Időkezelés"),
        classList: [],
        visible: true,
        key: "time",
        items: [{
          link: "/",
          icon: "",
          label: $tf("sidebar.time.overview|Áttekintés"),
          visible: true,
          key: "time.overview"
        }, {
          link: "/time-management/logging",
          icon: "",
          label: $tf("sidebar.time.timeLogging|Időkövetés"),
          visible: true,
          key: "time.timeLogging"
        }, {
          link: "/my-requests",
          icon: "",
          label: $tf("sidebar.time.myRequests|My requests"),
          visible: true,
          key: "time.myRequests"
        }, {
          link: "/requests",
          icon: "",
          label: $tf("sidebar.time.requests|Requests"),
          visible: true,
          key: "time.requests"
        }]
      }, {
        icon: "fa-regular fa-users",
        label: $tf("sidebar.resource|Erőforrások"),
        classList: [],
        visible: true,
        key: "resource",
        items: [{
          link: "/ralloc/utilization",
          icon: "",
          label: $tf("sidebar.resource.resourcePlanner|Erőforrás-tervezés"),
          visible: true,
          key: "resource.resourcePlanner"
        }, {
          link: "/employee-explorer",
          icon: "",
          label: $tf("sidebar.resource.employeeExplorer|Felhasználó-böngésző"),
          visible: true,
          key: "resource.employeeExplorer"
        }, {
          link: "/teams",
          icon: "",
          label: $tf("sidebar.resource.teams|Csapatok"),
          visible: true,
          key: "resource.teams"
        }]
      }, {
        icon: "fa-regular fa-briefcase",
        label: $tf("sidebar.projects.menu|Projektek"),
        classList: [],
        visible: true,
        key: "projects",
        items: [{
          link: "/projects/list#all",
          icon: "",
          label: $tf("sidebar.projects.all|Összevont"),
          visible: true,
          key: "projects.all"
        }, {
          link: "/projects/worklog",
          icon: "",
          label: $tf("sidebar.projects.worklog|Munkaütemezés"),
          visible: true,
          key: "projects.worklog"
        }, {
          link: "/projects/task",
          icon: "",
          label: $tf("sidebar.projects.task|Feladatok"),
          visible: true,
          key: "projects.task"
        }, {
          link: "/projects/clients",
          icon: "",
          label: $tf("sidebar.projects.clients|Ügyfelek"),
          visible: true,
          key: "projects.clients"
        }, {
          link: "",
          icon: "",
          label: $tf("sidebar.projects.externalCosts|Külső költségek"),
          visible: true,
          comingSoon: true,
          key: "projects.externalCosts"
        }, {
          link: "",
          icon: "",
          label: $tf("sidebar.projects.invoices|Számlák"),
          visible: true,
          comingSoon: true,
          key: "projects.invoices"
        }]
      }, {
        icon: "fa-regular fa-book",
        label: $tf("sidebar.reporting.menu|Riportok"),
        classList: [],
        visible: true,
        key: "reporting",
        comingSoon: true,
        items: []
      }];
    });

    // Active menu key detection
    var openMenuKeys = computed(function () {
      var _route$meta;
      var currentPath = route.path;
      var currentFullPath = route.fullPath;
      var currentSidebarKey = (_route$meta = route.meta) === null || _route$meta === void 0 ? void 0 : _route$meta.sidebarItemKey;
      var keys = new Set();
      var _findActiveBranch = function findActiveBranch(items) {
        var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var _iterator = _createForOfIteratorHelper(items),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _item$items2;
            var item = _step.value;
            if (!item.link) {
              var _item$items;
              if ((_item$items = item.items) !== null && _item$items !== void 0 && _item$items.length) {
                var childMatch = _findActiveBranch(item.items, [].concat(_toConsumableArray(parents), [item.key]));
                if (childMatch) return true;
              }
              continue;
            }
            var linkParts = item.link.split("#");
            var linkPath = linkParts[0];
            var linkHash = linkParts[1] ? "#" + linkParts[1] : null;
            var pathMatches = false;
            if (linkHash) {
              var currentHash = currentFullPath.includes("#") ? "#" + currentFullPath.split("#")[1] : null;
              pathMatches = currentPath === linkPath && currentHash === linkHash;
            } else {
              pathMatches = currentPath === item.link || currentPath.startsWith(item.link + "/");
            }
            var keyMatches = currentSidebarKey && item.key === currentSidebarKey;
            if (pathMatches || keyMatches) {
              parents.forEach(function (key) {
                return keys.add(key);
              });
              if (item.key) keys.add(item.key);
              return true;
            }
            if ((_item$items2 = item.items) !== null && _item$items2 !== void 0 && _item$items2.length) {
              var _childMatch = _findActiveBranch(item.items, [].concat(_toConsumableArray(parents), [item.key]));
              if (_childMatch) return true;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return false;
      };
      _findActiveBranch(menuItems.value);
      return keys;
    });

    // Methods
    function toggleProfileMenu(event) {
      profileMenu.value.toggle(event);
    }
    function toggleMenu(menu) {
      var idx = openedMenus.value.indexOf(menu);
      if (idx !== -1) {
        openedMenus.value.splice(idx, 1);
      } else {
        openedMenus.value.push(menu);
      }
    }
    function logout() {
      return _logout.apply(this, arguments);
    } // Lifecycle
    function _logout() {
      _logout = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return store.dispatch("session/logMeOut");
            case 1:
              router.push("/login");
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return _logout.apply(this, arguments);
    }
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            openedMenus.value = ["dashboard", "time", "resource", "projects", "reporting"];
          case 1:
            return _context.a(2);
        }
      }, _callee);
    })));
    return function (_ctx, _cache) {
      var _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
        custom: "",
        to: "/"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
            src: logo.value,
            alt: "logo",
            class: "cursor-pointer"
          }, null, 8, _hoisted_5)])];
        }),
        _: 1
      }), _createElementVNode("div", _hoisted_6, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "font-bold"
      }, "Forecastify", -1)), _createElementVNode("div", _hoisted_7, _toDisplayString(tenantBadge.value), 1)])]), _createElementVNode("div", _hoisted_8, [_createVNode(CommandKSearch)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("ul", _hoisted_10, [_createElementVNode("li", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, function (menuItem) {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: menuItem.key
        }, [menuItem.link && menuItem.visible ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: menuItem.link,
          class: "flex items-center cursor-pointer p-2 gap-4 rounded-lg text-surface-900 hover:bg-surface-50 border border-transparent hover:border-surface-100 transition-colors duration-150"
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("i", {
              class: _normalizeClass("".concat(menuItem.icon, " !text-sm !leading-none text-surface-500hover:text-surface-900 "))
            }, null, 2), _createElementVNode("span", {
              class: _normalizeClass(["font-medium text-sm leading-tight", {
                'text-primary-500': openMenuKeys.value.has(menuItem.key)
              }])
            }, _toDisplayString(menuItem.label), 3)];
          }),
          _: 2
        }, 1032, ["to"])) : menuItem.items && menuItem.visible ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("div", {
          onClick: function onClick($event) {
            return toggleMenu(menuItem.key);
          },
          class: "flex items-center justify-between cursor-pointer p-2 gap-2 rounded-lg text-surface-900 hover:bg-surface-50 border border-transparent hover:border-surface-100 transition-colors duration-150"
        }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("i", {
          class: _normalizeClass("".concat(menuItem.icon, " !text-sm !leading-none text-surface-500 hover:text-surface-900 w-4"))
        }, null, 2), _createElementVNode("div", _hoisted_13, [_createElementVNode("span", {
          class: _normalizeClass(["font-medium text-sm leading-tight", {
            'text-primary-500': openMenuKeys.value.has(menuItem.key)
          }])
        }, _toDisplayString(menuItem.label), 3), menuItem.comingSoon ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref($tf)("sidebar.dashboard.soon|hamarosan")), 1)) : _createCommentVNode("", true)])]), menuItem.items.length > 0 ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: _normalizeClass(["fa-regular fa-chevron-right !text-xs !leading-none text-surface-500 ml-auto transition-transform", {
            '-rotate-90': openedMenus.value.includes(menuItem.key)
          }])
        }, null, 2)) : _createCommentVNode("", true)], 8, _hoisted_11), _createElementVNode("ul", {
          class: _normalizeClass([[openedMenus.value.includes(menuItem.key) ? 'max-h-full' : 'max-h-0'], "ml-4 pl-0 translate-x-[-1px] border-l border-surface-200 list-none m-0 overflow-hidden flex flex-col transition-[max-height] duration-500 ease-in-out"])
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.items, function (menuSubItem) {
          return _withDirectives((_openBlock(), _createElementBlock("li", {
            key: menuSubItem.key
          }, [(_openBlock(), _createBlock(_resolveDynamicComponent(menuSubItem.link ? 'router-link' : 'div'), {
            to: menuSubItem.link || undefined,
            class: _normalizeClass(["flex items-center p-2 gap-2 rounded-lg text-surface-900 hover:bg-surface-50 border border-transparent hover:border-surface-100 transition-colors duration-150 hover:text-surface-900", menuSubItem.link ? 'cursor-pointer' : 'cursor-default'])
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("i", {
                class: _normalizeClass("".concat(menuSubItem.icon, " !text-sm !leading-none text-surface-500 hover:text-surface-900"))
              }, null, 2), _createElementVNode("span", {
                class: _normalizeClass(["font-medium text-sm leading-tight", {
                  'text-primary-500': openMenuKeys.value.has(menuSubItem.key)
                }])
              }, _toDisplayString(menuSubItem.label), 3), menuSubItem.key === 'time.requests' ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(pendingRequestsCount.value), 1)) : menuSubItem.comingSoon ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref($tf)("sidebar.dashboard.soon|hamarosan")), 1)) : _createCommentVNode("", true)];
            }),
            _: 2
          }, 1032, ["to", "class"]))])), [[_vShow, menuSubItem.visible]]);
        }), 128))], 2)], 64)) : _createCommentVNode("", true)], 64);
      }), 128))])])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("a", {
        onClick: toggleProfileMenu,
        class: "flex items-center cursor-pointer p-3.5 gap-2 text-surface-900 hover: transition-colors duration-150 border-t border-surface-200"
      }, [_createElementVNode("img", {
        src: avatar.value,
        alt: "Avatar",
        class: "w-8 h-8 rounded-full"
      }, null, 8, _hoisted_18), _createElementVNode("span", _hoisted_19, _toDisplayString(displayName.value), 1), _cache[2] || (_cache[2] = _createElementVNode("i", {
        class: "fa-regular fa-angles-up-down !text-sm !leading-none text-surface-500 ml-auto"
      }, null, -1))]), _createVNode(_unref(Popover), {
        ref_key: "profileMenu",
        ref: profileMenu,
        pt: {
          root: {
            class: 'w-[260px] !ml-2.5',
            style: {
              padding: '0 !important'
            }
          }
        }
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("ul", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createVNode(LanguageSelector, {
            class: "w-full"
          }), _createVNode(ThemeSelector, {
            class: "w-full"
          })]), _createElementVNode("div", _hoisted_22, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
            to: "/profile#general",
            class: "flex items-center cursor-pointer p-2 gap-2 rounded-lg text-surface-700 hover:bg-surface-50 border border-transparent hover:border-surface-200 transition-colors duration-150 hover:text-surface-900 w-full",
            onClick: toggleProfileMenu
          }, {
            default: _withCtx(function () {
              return [_cache[3] || (_cache[3] = _createElementVNode("i", {
                class: "fa-regular fa-user !text-sm !leading-none"
              }, null, -1)), _createElementVNode("span", _hoisted_23, _toDisplayString(_unref($tf)("sidebar.profile|Profil")), 1)];
            }),
            _: 1
          })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
            to: "/settings",
            class: "flex items-center cursor-pointer p-2 gap-2 rounded-lg text-surface-700 hover:bg-surface-50 border border-transparent hover:border-surface-200 transition-colors duration-150 hover:text-surface-900 w-full",
            onClick: toggleProfileMenu
          }, {
            default: _withCtx(function () {
              return [_cache[4] || (_cache[4] = _createElementVNode("i", {
                class: "fa-regular fa-gear !text-sm !leading-none"
              }, null, -1)), _createElementVNode("span", _hoisted_24, _toDisplayString(_unref($tf)("sidebar.settings.menu|Beállítások")), 1)];
            }),
            _: 1
          })])]), _createElementVNode("li", _hoisted_25, [_createElementVNode("a", {
            class: "flex items-center cursor-pointer p-2 gap-2 rounded-lg text-surface-700 hover:bg-surface-50 border border-transparent hover:border-surface-200 transition-colors duration-150 hover:text-surface-900 w-full",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return logout();
            })
          }, [_cache[5] || (_cache[5] = _createElementVNode("i", {
            class: "fa-regular fa-sign-out !text-sm !leading-none text-red-500 dark:text-red-700"
          }, null, -1)), _createElementVNode("span", _hoisted_26, _toDisplayString(_unref($tf)("sidebar.logout|Kilépés")), 1)])])])];
        }),
        _: 1
      }, 512)])])]);
    };
  }
};